import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MfaConfirmationScreen } from '@/entities/mfa-identity';
import { ModalComponentWrapper } from '@/shared/components';
import {
  type TwoFactorIdentityConfirmationDisableModalArgs,
  useTwoFactorIdentityDisableForm,
} from '../model';
import { sendTwoFactorIdentityCode } from '../api/requests';
import { MFA_IDENTITY_TYPES } from '@/entities/mfa-identity';

const TwoFactorIdentityDisableFormModal = ({
  identityType,
  state,
  onBack,
  onSuccess,
}: TwoFactorIdentityConfirmationDisableModalArgs) => {
  const { t } = useTranslation();
  const [maskedContact, setMaskedContact] = useState('');
  const localePath = 'authPages.identityConfirmationForm';

  const {
    disableForm,
    disableTwoFactorData,
    isDisableTwoFactorLoading,
    disableTwoFactorSubmit,
  } = useTwoFactorIdentityDisableForm({
    identityType,
    state,
    onSuccess,
  });

  const disableTwoFactorError = useMemo(() => {
    if (
      disableTwoFactorData &&
      typeof disableTwoFactorData === 'object' &&
      'message' in disableTwoFactorData
    ) {
      return disableTwoFactorData.message;
    }
    return undefined;
  }, [disableTwoFactorData]);

  const descriptionText = useMemo(() => {
    if (identityType === MFA_IDENTITY_TYPES.GOOGLE_AUTHENTICATOR) {
      return t(`${localePath}.appDescription`);
    }
    return maskedContact
      ? t(`${localePath}.description`) + ' ' + maskedContact
      : '';
  }, [identityType, t, localePath, maskedContact]);

  return (
    <ModalComponentWrapper
      title={t(`${localePath}.title`)}
      description={descriptionText}
      onBack={onBack}>
      <MfaConfirmationScreen
        form={disableForm}
        identityType={identityType}
        mfaCodeFieldName="twoFA.code"
        sendOtpCodeMutationFn={sendTwoFactorIdentityCode}
        setMaskedContact={setMaskedContact}
        onSubmit={disableTwoFactorSubmit}
        isSubmitLoading={isDisableTwoFactorLoading}
        submitError={disableTwoFactorError}
      />
    </ModalComponentWrapper>
  );
};

export { TwoFactorIdentityDisableFormModal };
